module.exports = __webpack_public_path__ + "static/media/New_payment_icon.956f656c.svg";